var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitStakeHolderData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.name"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  ref: "name",
                  attrs: {
                    invalid: _vm.$v.formData.name.$error,
                    type: "text",
                    name: "name",
                    "tab-index": "1",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.name.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.name.$error
                  ? _c("div", [
                      !_vm.$v.formData.name.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.name.minLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$tc(
                                    "validation.name_min_length",
                                    _vm.$v.formData.name.$params.minLength.min,
                                    {
                                      count:
                                        _vm.$v.formData.name.$params.minLength
                                          .min,
                                    }
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.cnic"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.formData.cnic.$error,
                    type: "text",
                    "tab-index": "1",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.cnic.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.cnic,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "cnic", $$v)
                    },
                    expression: "formData.cnic",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.cnic.$error
                  ? _c("div", [
                      !_vm.$v.formData.cnic.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.cnic.numeric
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.numbers_only")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.cnic.minLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$tc(
                                    "validation.cnic_min_length",
                                    _vm.$v.formData.cnic.$params.minLength.min,
                                    {
                                      count:
                                        _vm.$v.formData.cnic.$params.minLength
                                          .min,
                                    }
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.cnic.maxLength
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$tc(
                                    "validation.cnic_max_length",
                                    _vm.$v.formData.cnic.$params.maxLength.max,
                                    {
                                      count:
                                        _vm.$v.formData.cnic.$params.maxLength
                                          .max,
                                    }
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.role"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.role.$error },
                  attrs: {
                    options: _vm.roleOptions,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t("profile.stakeholder.role"),
                  },
                  model: {
                    value: _vm.formData.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "role", $$v)
                    },
                    expression: "formData.role",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.role.$error
                  ? _c("div", [
                      !_vm.$v.formData.role.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("profile.stakeholder.executive_nonexecutive"))
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.type.$error },
                  attrs: {
                    options: _vm.typeOptions,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t("profile.stakeholder.type"),
                  },
                  model: {
                    value: _vm.formData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "type", $$v)
                    },
                    expression: "formData.type",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.type.$error
                  ? _c("div", [
                      !_vm.$v.formData.type.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.$tc("validation.required"))),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.email"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    invalid: _vm.$v.formData.email.$error,
                    type: "text",
                    name: "email",
                    "tab-index": "3",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.email.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.email,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "email",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.email",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.email.$error
                  ? _c("div", [
                      !_vm.$v.formData.email.email
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$tc("validation.email_incorrect")) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.address"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text" },
                  model: {
                    value: _vm.formData.address,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "address", $$v)
                    },
                    expression: "formData.address",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_office"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", name: "phone", "tab-index": "4" },
                  model: {
                    value: _vm.formData.phone_office,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "phone_office",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.phone_office",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_res"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", name: "phone", "tab-index": "4" },
                  model: {
                    value: _vm.formData.phone_res,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "phone_res",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.phone_res",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_cell"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", name: "phone", "tab-index": "4" },
                  model: {
                    value: _vm.formData.phone_cell,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "phone_cell",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.phone_cell",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.fax"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", "tab-index": "4" },
                  model: {
                    value: _vm.formData.fax,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "fax",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.fax",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("profile.stakeholder.national_tax_num"))
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", "tab-index": "4" },
                  model: {
                    value: _vm.formData.national_tax,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "national_tax",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.national_tax",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("profile.stakeholder.share_holding"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", "tab-index": "4" },
                  model: {
                    value: _vm.formData.share_holding,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "share_holding", $$v)
                    },
                    expression: "formData.share_holding",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.amount"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.amount.$error },
                        model: {
                          value: _vm.amount,
                          callback: function ($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount",
                        },
                      },
                      "money",
                      _vm.defaultCurrencyForInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.amount.$error
                ? _c("div", [
                    !_vm.$v.formData.amount.numeric
                      ? _c("span", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.$tc("validation.numbers_only"))),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("profile.stakeholder.per_share_holding"))
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  attrs: { type: "text", "tab-index": "4" },
                  model: {
                    value: _vm.formData.per_share_holding,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "per_share_holding", $$v)
                    },
                    expression: "formData.per_share_holding",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeStakeHolderModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      !_vm.isEdit
                        ? _vm.$t("general.save")
                        : _vm.$t("general.update")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }